'use strict'
var __importDefault =
  (this && this.__importDefault) ||
  function (mod) {
    return mod && mod.__esModule ? mod : { default: mod }
  }
exports.__esModule = true
exports.formatPrice = exports.currencyMap = void 0
var format_es5_js_1 = __importDefault(
  require('number-format.js/lib/format.es5.js'),
)
exports.currencyMap = {
  AED: { code: 'AED', symbol: 'AED' },
  AFN: { code: 'AFN', symbol: 'Afs' },
  ALL: { code: 'ALL', symbol: 'L' },
  AMD: { code: 'AMD', symbol: 'AMD' },
  AOA: { code: 'AOA', symbol: 'Kz' },
  ARS: { code: 'ARS', symbol: 'AR$' },
  AUD: { code: 'AUD', symbol: 'A$' },
  AZN: { code: 'AZN', symbol: 'AZN' },
  BAM: { code: 'BAM', symbol: 'KM' },
  BDT: { code: 'BDT', symbol: '৳' },
  BGN: { code: 'BGN', symbol: 'лв' },
  BHD: { code: 'BHD', symbol: 'BD' },
  BND: { code: 'BND', symbol: 'B$' },
  BOB: { code: 'BOB', symbol: '$b' },
  BRL: { code: 'BRL', symbol: 'R$' },
  BYR: { code: 'BYR', symbol: 'p.' },
  CAD: { code: 'CAD', symbol: 'CA$' },
  CHF: { code: 'CHF', symbol: 'CHF' },
  CLP: { code: 'CLP', symbol: 'CL$' },
  CNY: { code: 'CNY', symbol: '¥' },
  COP: { code: 'COP', symbol: 'CO$' },
  CRC: { code: 'CRC', symbol: '₡' },
  CUC: { code: 'CUC', symbol: 'CUC$' },
  CZK: { code: 'CZK', symbol: 'Kč' },
  DKK: { code: 'DKK', symbol: 'kr' },
  DOP: { code: 'DOP', symbol: 'RD$' },
  DZD: { code: 'DZD', symbol: 'DA' },
  EGP: { code: 'EGP', symbol: 'E£' },
  EUR: { code: 'EUR', symbol: '€' },
  FJD: { code: 'FJD', symbol: 'FJ$' },
  GBP: { code: 'GBP', symbol: '£' },
  HKD: { code: 'HKD', symbol: 'HK$' },
  HRK: { code: 'HRK', symbol: 'kn' },
  HUF: { code: 'HUF', symbol: 'Ft' },
  IDR: { code: 'IDR', symbol: 'Rp' },
  ILS: { code: 'ILS', symbol: '₪' },
  INR: { code: 'INR', symbol: '₹' },
  IQD: { code: 'IQD', symbol: 'IQD' },
  IRR: { code: 'IRR', symbol: 'IRR' },
  ISK: { code: 'ISK', symbol: 'kr' },
  JMD: { code: 'JMD', symbol: 'J$' },
  JPY: { code: 'JPY', symbol: '¥' },
  KES: { code: 'KES', symbol: 'KSh' },
  KRW: { code: 'KRW', symbol: '₩' },
  KWD: { code: 'KWD', symbol: 'K.D.' },
  KZT: { code: 'KZT', symbol: '₸' },
  LBP: { code: 'LBP', symbol: 'LBP' },
  LKR: { code: 'LKR', symbol: 'Rs' },
  MAD: { code: 'MAD', symbol: 'MAD' },
  MKD: { code: 'MKD', symbol: 'ден' },
  MOP: { code: 'MOP', symbol: 'MOP$' },
  MXN: { code: 'MXN', symbol: 'MXN', prefix: '$' },
  MYR: { code: 'MYR', symbol: 'RM' },
  NGN: { code: 'NGN', symbol: '₦' },
  PEN: { code: 'PEN', symbol: 'S/' },
  PHP: { code: 'PHP', symbol: '₱' },
  PKR: { code: 'PKR', symbol: '₨' },
  PLN: { code: 'PLN', symbol: 'zł' },
  PYG: { code: 'PYG', symbol: '₲' },
  QAR: { code: 'QAR', symbol: 'QR' },
  RON: { code: 'RON', symbol: 'RON' },
  RSD: { code: 'RSD', symbol: 'din' },
  RUB: { code: 'RUB', symbol: 'руб' },
  SAR: { code: 'SAR', symbol: 'SR' },
  SEK: { code: 'SEK', symbol: 'kr' },
  SGD: { code: 'SGD', symbol: 'S$' },
  THB: { code: 'THB', symbol: '฿' },
  TND: { code: 'TND', symbol: 'DT' },
  TRY: { code: 'TRY', symbol: 'TRY' },
  TWD: { code: 'TWD', symbol: 'NT$' },
  UAH: { code: 'UAH', symbol: '₴' },
  USD: { code: 'USD', symbol: '$' },
  UYU: { code: 'UYU', symbol: '$U' },
  UZS: { code: 'UZS', symbol: 'лв' },
  VEF: { code: 'VEF', symbol: 'Bs.' },
  VND: { code: 'VND', symbol: '₫' },
  WST: { code: 'WST', symbol: 'WS$' },
  XCD: { code: 'XCD', symbol: 'EC$' },
  ZAR: { code: 'ZAR', symbol: 'R' },
  NOK: { code: 'NOK', symbol: 'kr' },
  NZD: { code: 'NZD', symbol: 'NZ$' },
  OMR: { code: 'OMR', symbol: 'OMR' },
}
exports.formatPrice = function (isoCode, price, locale) {
  var formatEuro = function (price, locale) {
    switch (locale) {
      case 'de_DE':
      case 'fr_FR':
      case 'es_ES':
      case 'fi_FI':
        return format_es5_js_1['default'](
          '0,00 ' + exports.currencyMap.EUR.symbol,
          price,
        )
      case 'en_IE':
      case 'en_GB':
      case 'zh_CN':
        return prefixSymbol(
          format_es5_js_1['default']('0.00', price),
          exports.currencyMap.EUR.symbol,
        )
      case 'nl_NL':
      case 'nl_BE':
        return prefixSymbol(
          format_es5_js_1['default']('0,00', price),
          exports.currencyMap.EUR.symbol,
        )
      default:
        return format_es5_js_1['default'](
          '#,##0.00' + exports.currencyMap.EUR.symbol,
          price,
        )
    }
  }
  var prefixSymbol = function (formattedPrice, symbol, withSpace) {
    if (formattedPrice.split('').indexOf('-') !== -1) {
      return withSpace
        ? '-' + symbol + ' ' + formattedPrice.replace('-', '')
        : '-' + symbol + formattedPrice.replace('-', '')
    }
    return withSpace
      ? symbol + ' ' + formattedPrice
      : '' + symbol + formattedPrice
  }
  switch (isoCode) {
    case exports.currencyMap.AED.code:
      return format_es5_js_1['default'](
        '#,##0.00 ' + exports.currencyMap.AED.symbol,
        price,
      )
    case exports.currencyMap.AFN.code:
      return prefixSymbol(
        format_es5_js_1['default']('0', price),
        exports.currencyMap.AFN.symbol,
      )
    case exports.currencyMap.ALL.code:
      return prefixSymbol(
        format_es5_js_1['default']('0', price),
        exports.currencyMap.ALL.symbol,
      )
    case exports.currencyMap.AMD.code:
      return prefixSymbol(
        format_es5_js_1['default']('#,##0.', price),
        exports.currencyMap.AMD.symbol,
        true,
      )
    case exports.currencyMap.AOA.code:
      return prefixSymbol(
        format_es5_js_1['default']('0', price),
        exports.currencyMap.AOA.symbol,
      )
    case exports.currencyMap.ARS.code:
      return prefixSymbol(
        format_es5_js_1['default']('# ##0,00', price),
        exports.currencyMap.ARS.symbol,
      )
    case exports.currencyMap.AUD.code:
      return prefixSymbol(
        format_es5_js_1['default']('0.00', price),
        exports.currencyMap.AUD.symbol,
      )
    case exports.currencyMap.AZN.code:
      return format_es5_js_1['default'](
        '0,00 ' + exports.currencyMap.AZN.symbol,
        price,
      )
    case exports.currencyMap.BAM.code:
      return format_es5_js_1['default'](
        '#,##0.00' + exports.currencyMap.BAM.symbol,
        price,
      )
    case exports.currencyMap.BDT.code:
      return prefixSymbol(
        format_es5_js_1['default']('#,##0.', price),
        exports.currencyMap.BDT.symbol,
      )
    case exports.currencyMap.BGN.code:
      return format_es5_js_1['default'](
        '0,00 ' + exports.currencyMap.BGN.symbol,
        price,
      )
    case exports.currencyMap.BHD.code:
      return prefixSymbol(
        format_es5_js_1['default']('#,##0.000', price),
        exports.currencyMap.BHD.symbol,
      )
    case exports.currencyMap.BND.code:
      return prefixSymbol(
        format_es5_js_1['default']('#,##0.00', price),
        exports.currencyMap.BND.symbol,
      )
    case exports.currencyMap.BOB.code:
      return prefixSymbol(
        format_es5_js_1['default']('#,##0.00', price),
        exports.currencyMap.BOB.symbol,
      )
    case exports.currencyMap.BRL.code:
      return prefixSymbol(
        format_es5_js_1['default']('0,00', price),
        exports.currencyMap.BRL.symbol,
        true,
      )
    case exports.currencyMap.BYR.code:
      return prefixSymbol(
        format_es5_js_1['default']('0.', price),
        exports.currencyMap.BYR.symbol,
      )
    case exports.currencyMap.CAD.code:
      return prefixSymbol(
        format_es5_js_1['default']('0.00', price),
        exports.currencyMap.CAD.symbol,
      )
    case exports.currencyMap.CHF.code:
      return prefixSymbol(
        format_es5_js_1['default']('0.00', price),
        exports.currencyMap.CHF.symbol,
        true,
      )
    case exports.currencyMap.CLP.code:
      return prefixSymbol(
        format_es5_js_1['default']('# ##0.', price),
        exports.currencyMap.CLP.symbol,
      )
    case exports.currencyMap.CNY.code:
      return prefixSymbol(
        format_es5_js_1['default']('0.00', price),
        exports.currencyMap.CNY.symbol,
      )
    case exports.currencyMap.COP.code:
      return prefixSymbol(
        format_es5_js_1['default']('# ##0.', price),
        exports.currencyMap.COP.symbol,
      )
    case exports.currencyMap.CRC.code:
      return prefixSymbol(
        format_es5_js_1['default']('# ##0,00', price),
        exports.currencyMap.CRC.symbol,
      )
    case exports.currencyMap.CUC.code:
      return prefixSymbol(
        format_es5_js_1['default']('#,##0.00', price),
        exports.currencyMap.CUC.symbol,
      )
    case exports.currencyMap.CZK.code:
      return format_es5_js_1['default'](
        '0.00 ' + exports.currencyMap.CZK.symbol,
        price,
      )
    case exports.currencyMap.DKK.code:
      return format_es5_js_1['default'](
        '0. ' + exports.currencyMap.DKK.symbol,
        price,
      )
    case exports.currencyMap.DOP.code:
      return prefixSymbol(
        format_es5_js_1['default']('#,##0.', price),
        exports.currencyMap.DOP.symbol,
      )
    case exports.currencyMap.DZD.code:
      return format_es5_js_1['default'](
        '0.' + exports.currencyMap.DZD.symbol,
        price,
      )
    case exports.currencyMap.EGP.code:
      return prefixSymbol(
        format_es5_js_1['default']('#,##0.00', price),
        exports.currencyMap.EGP.symbol,
      )
    case exports.currencyMap.EUR.code:
      return formatEuro(price, locale)
    case exports.currencyMap.FJD.code:
      return prefixSymbol(
        format_es5_js_1['default']('#,##0.00', price),
        exports.currencyMap.FJD.symbol,
      )
    case exports.currencyMap.GBP.code:
      return prefixSymbol(
        format_es5_js_1['default']('#,##0.00', price),
        exports.currencyMap.GBP.symbol,
      )
    case exports.currencyMap.HKD.code:
      return prefixSymbol(
        format_es5_js_1['default']('0.00', price),
        exports.currencyMap.HKD.symbol,
      )
    case exports.currencyMap.HRK.code:
      return format_es5_js_1['default'](
        '0,00 ' + exports.currencyMap.HRK.symbol,
        price,
      )
    case exports.currencyMap.HUF.code:
      return format_es5_js_1['default'](
        '0 000. ' + exports.currencyMap.HUF.symbol,
        price,
      )
    case exports.currencyMap.IDR.code:
      return prefixSymbol(
        format_es5_js_1['default']('#.##0,00', price),
        exports.currencyMap.IDR.symbol,
        true,
      )
    case exports.currencyMap.ILS.code:
      return format_es5_js_1['default'](
        '0,00 ' + exports.currencyMap.ILS.symbol,
        price,
      )
    case exports.currencyMap.INR.code:
      return prefixSymbol(
        format_es5_js_1['default']('0.', price),
        exports.currencyMap.INR.symbol,
      )
    case exports.currencyMap.IQD.code:
      return format_es5_js_1['default'](
        '#,##0. ' + exports.currencyMap.IQD.symbol,
        price,
      )
    case exports.currencyMap.IRR.code:
      return format_es5_js_1['default'](
        '#,##0. ' + exports.currencyMap.IRR.symbol,
        price,
      )
    case exports.currencyMap.ISK.code:
      return prefixSymbol(
        format_es5_js_1['default']('# ##0.', price),
        exports.currencyMap.ISK.symbol,
      )
    case exports.currencyMap.JMD.code:
      return prefixSymbol(
        format_es5_js_1['default']('#,##0.00', price),
        exports.currencyMap.JMD.symbol,
      )
    case exports.currencyMap.JPY.code:
      return prefixSymbol(
        format_es5_js_1['default']('#,##0.', price),
        exports.currencyMap.JPY.symbol,
      )
    case exports.currencyMap.KES.code:
      return prefixSymbol(
        format_es5_js_1['default']('#,##0.', price),
        exports.currencyMap.KES.symbol,
      )
    case exports.currencyMap.KRW.code:
      return prefixSymbol(
        format_es5_js_1['default']('#,##0.', price),
        exports.currencyMap.KRW.symbol,
      )
    case exports.currencyMap.KWD.code:
      return format_es5_js_1['default'](
        '#,##0.000' + exports.currencyMap.KWD.symbol,
        price,
      )
    case exports.currencyMap.KZT.code:
      return prefixSymbol(
        format_es5_js_1['default']('###0.', price),
        exports.currencyMap.KZT.symbol,
      )
    case exports.currencyMap.LBP.code:
      return format_es5_js_1['default'](
        '# ##0. ' + exports.currencyMap.LBP.symbol,
        price,
      )
    case exports.currencyMap.LKR.code:
      return prefixSymbol(
        format_es5_js_1['default']('#,##0.', price),
        exports.currencyMap.LKR.symbol,
      )
    case exports.currencyMap.MAD.code:
      return format_es5_js_1['default'](
        '###0.00 ' + exports.currencyMap.MAD.symbol,
        price,
      )
    case exports.currencyMap.MKD.code:
      return prefixSymbol(
        format_es5_js_1['default']('#,##0.', price),
        exports.currencyMap.MKD.symbol,
      )
    case exports.currencyMap.MOP.code:
      return prefixSymbol(
        format_es5_js_1['default']('#,##0.00', price),
        exports.currencyMap.MOP.symbol,
      )
    case exports.currencyMap.MXN.code:
      return prefixSymbol(
        format_es5_js_1['default'](
          '###0.00 ' + exports.currencyMap.MXN.symbol,
          price,
        ),
        exports.currencyMap.MXN.prefix,
        true,
      )
    case exports.currencyMap.MYR.code:
      return prefixSymbol(
        format_es5_js_1['default']('#,##0.00', price),
        exports.currencyMap.MYR.symbol,
      )
    case exports.currencyMap.NGN.code:
      return prefixSymbol(
        format_es5_js_1['default']('###0.', price),
        exports.currencyMap.NGN.symbol,
      )
    case exports.currencyMap.NOK.code:
      return prefixSymbol(
        format_es5_js_1['default']('0,00', price),
        exports.currencyMap.NOK.symbol,
      )
    case exports.currencyMap.NZD.code:
      return prefixSymbol(
        format_es5_js_1['default']('0.00', price),
        exports.currencyMap.NZD.symbol,
      )
    case exports.currencyMap.OMR.code:
      return format_es5_js_1['default'](
        '#,##0.000 ' + exports.currencyMap.OMR.symbol,
        price,
      )
    case exports.currencyMap.PEN.code:
      return prefixSymbol(
        format_es5_js_1['default']('#,##0.00', price),
        exports.currencyMap.PEN.symbol,
      )
    case exports.currencyMap.PHP.code:
      return prefixSymbol(
        format_es5_js_1['default']('#,##0.', price),
        exports.currencyMap.PHP.symbol,
      )
    case exports.currencyMap.PKR.code:
      return prefixSymbol(
        format_es5_js_1['default']('#,##0.', price),
        exports.currencyMap.PKR.symbol,
      )
    case exports.currencyMap.PLN.code:
      return format_es5_js_1['default'](
        '0.00 ' + exports.currencyMap.PLN.symbol,
        price,
      )
    case exports.currencyMap.PYG.code:
      return prefixSymbol(
        format_es5_js_1['default']('0', price),
        exports.currencyMap.PYG.symbol,
      )
    case exports.currencyMap.QAR.code:
      return format_es5_js_1['default'](
        '0.00' + exports.currencyMap.QAR.symbol,
        price,
      )
    case exports.currencyMap.RON.code:
      return format_es5_js_1['default'](
        '0.00' + exports.currencyMap.RON.symbol,
        price,
      )
    case exports.currencyMap.RSD.code:
      return format_es5_js_1['default'](
        '0' + exports.currencyMap.RSD.symbol,
        price,
      )
    case exports.currencyMap.RUB.code:
      return format_es5_js_1['default'](
        '# ##0. ' + exports.currencyMap.RUB.symbol,
        price,
      )
    case exports.currencyMap.SAR.code:
      return format_es5_js_1['default'](
        '#,##0.00' + exports.currencyMap.SAR.symbol,
        price,
      )
    case exports.currencyMap.SEK.code:
      return format_es5_js_1['default'](
        '0 ' + exports.currencyMap.SEK.symbol,
        price,
      )
    case exports.currencyMap.SGD.code:
      return prefixSymbol(
        format_es5_js_1['default']('0.00', price),
        exports.currencyMap.SGD.symbol,
      )
    case exports.currencyMap.THB.code:
      return prefixSymbol(
        format_es5_js_1['default']('#,##0.00', price),
        exports.currencyMap.THB.symbol,
      )
    case exports.currencyMap.TND.code:
      return format_es5_js_1['default'](
        '0.00' + exports.currencyMap.TND.symbol,
        price,
      )
    case exports.currencyMap.TRY.code:
      return prefixSymbol(
        format_es5_js_1['default']('#,##0.000', price),
        exports.currencyMap.TRY.symbol,
        true,
      )
    case exports.currencyMap.TWD.code:
      return prefixSymbol(
        format_es5_js_1['default']('0', price),
        exports.currencyMap.TWD.symbol,
      )
    case exports.currencyMap.UAH.code:
      return prefixSymbol(
        format_es5_js_1['default']('# ##0,00', price),
        exports.currencyMap.UAH.symbol,
        true,
      )
    case exports.currencyMap.USD.code:
      return prefixSymbol(
        format_es5_js_1['default']('0.00', price),
        exports.currencyMap.USD.symbol,
      )
    case exports.currencyMap.UYU.code:
      return prefixSymbol(
        format_es5_js_1['default']('# ##0.', price),
        exports.currencyMap.UYU.symbol,
      )
    case exports.currencyMap.UZS.code:
      return prefixSymbol(
        format_es5_js_1['default']('0', price),
        exports.currencyMap.UZS.symbol,
      )
    case exports.currencyMap.VEF.code:
      return prefixSymbol(
        format_es5_js_1['default']('# ##0,00', price),
        exports.currencyMap.VEF.symbol,
      )
    case exports.currencyMap.VND.code:
      return prefixSymbol(
        format_es5_js_1['default']('# ##0.', price),
        exports.currencyMap.VND.symbol,
      )
    case exports.currencyMap.WST.code:
      return prefixSymbol(
        format_es5_js_1['default']('#,##0.00', price),
        exports.currencyMap.WST.symbol,
      )
    case exports.currencyMap.XCD.code:
      return prefixSymbol(
        format_es5_js_1['default']('#,##0.00', price),
        exports.currencyMap.XCD.symbol,
      )
    case exports.currencyMap.ZAR.code:
      return prefixSymbol(
        format_es5_js_1['default']('0.00', price),
        exports.currencyMap.ZAR.symbol,
      )
    default:
      try {
        var formatter = new Intl.NumberFormat(locale.replace('_', '-'), {
          currency: isoCode,
          style: 'currency',
        })
        return formatter.format(price)
      } catch (e) {
        return format_es5_js_1['default']('0.00', price)
      }
  }
}
